import {
  Box,
  Button2,
  Menu,
  MenuItem,
  MenuRadio,
  MenuRadioGroup,
  Text,
  theme,
  VisuallyHidden,
} from '@frameio/vapor';
import { IconChevronDown } from '@frameio/vapor-icons';
import { SettingRow } from '../../../../shared/components/DocumentExports/ExportFormFields';
import TEXT from './generated/TEXT/PresetSelectRow';

TEXT.DEFINE({
  /** Label for custom preset option (user presets) */
  custom: 'Custom',
  /** Label for favorite export presets */
  favorites: 'Favorites',
  /** Button label to open Premiere Pro preset manager modal */
  managePresets: 'Manage Presets',
  /** Label for the preset selection dropdown */
  preset: 'Preset',
});

type PresetOption = {
  label: string;
  value: string;
};

type PresetSelectRowProps = {
  canManagePresets: boolean;
  customPresets: PresetOption[];
  favoritePresets: PresetOption[];
  onChange: (presetId: string) => void;
  onManagePresets: () => void;
  onRefetch: () => void;
  selectedPresetId?: string;
  selectedPresetName?: string;
};

export const PresetSelectRow = ({
  canManagePresets,
  customPresets,
  favoritePresets,
  onChange,
  onManagePresets,
  onRefetch,
  selectedPresetId,
  selectedPresetName,
}: PresetSelectRowProps) => {
  return (
    <SettingRow
      field={
        <Menu
          content={
            <>
              {favoritePresets.length > 0 && (
                <MenuRadioGroup
                  checked={selectedPresetId}
                  label={TEXT.favorites}
                  onChange={onChange}
                >
                  {favoritePresets.map((option) => (
                    <MenuRadio key={option.label} name={option.value}>
                      {option.label}
                    </MenuRadio>
                  ))}
                </MenuRadioGroup>
              )}

              {customPresets.length > 0 && (
                <MenuRadioGroup
                  checked={selectedPresetId}
                  label={TEXT.custom}
                  onChange={onChange}
                >
                  {customPresets.map((option) => (
                    <MenuRadio key={option.label} name={option.value}>
                      {option.label}
                    </MenuRadio>
                  ))}
                </MenuRadioGroup>
              )}
              {canManagePresets && (
                <div>
                  <MenuItem onPress={onManagePresets}>
                    {({ bind }) => (
                      <Box style={{ marginBottom: theme.spaces[8] }} {...bind}>
                        <Button2 block={true}>{TEXT.managePresets}</Button2>
                      </Box>
                    )}
                  </MenuItem>
                </div>
              )}
            </>
          }
          onRequestChange={(isShowing) => {
            if (isShowing) {
              onRefetch();
            }
          }}
          placement="bottom-end"
        >
          <Button2
            block={true}
            data-testid="preset-select"
            iconAfter={<IconChevronDown />}
            spaceBetween={true}
          >
            <VisuallyHidden>{TEXT.preset}</VisuallyHidden>
            <Text truncate={{ type: 'middle', padding: 5 }}>
              {selectedPresetName ?? TEXT.preset}
            </Text>
          </Button2>
        </Menu>
      }
      title={TEXT.preset}
    />
  );
};
